// --- 页面 4: AI工具箱 ---
function ToolsPage({ onNavigate }) {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-white">AI工具箱 页面</h1>
      <p className="text-gray-300 mt-2">这里将放置各种 AI 小工具。</p>
    </div>
  );
}

export default ToolsPage;
